import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SkyClubPageComponent } from '@com-delta-idp/mnx-sky-club-ui';
import { SharedModule } from '@com-delta-idp/mnx-skymiles-shared';
import { SkeletonLoaderDirective } from '@com-delta-omnichannel/aura';
import { PushPipe } from '@ngrx/component';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { ContentEffects } from './data-access/+state/effects/content.effects';
import { PurchaseEffects } from './data-access/+state/effects/purchase.effects';
import * as fromSkyClub from './data-access/+state/reducers/sky-club.reducer';
import { SkyClubComponent } from './entry-components/sky-club/sky-club.component';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    SkyClubPageComponent,
    PushPipe,
    SkeletonLoaderDirective,
    EffectsModule.forFeature([ContentEffects, PurchaseEffects]),
    StoreModule.forFeature(fromSkyClub.SKYCLUB_FEATURE_KEY, fromSkyClub.reducer)
  ],
  declarations: [SkyClubComponent],
  exports: [SkyClubComponent]
})
export class SmartModule {}
